import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./galleria.component.html?ngResource";
import { Component, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, } from '@angular/core';
const DEFAULT_NUM_VISIBLE = 4;
let GalleriaComponent = class GalleriaComponent {
    cdr;
    id;
    media = [];
    activeItemChange;
    selectionChange = new EventEmitter();
    videoElem;
    _activeIndex = 0;
    numVisible = DEFAULT_NUM_VISIBLE;
    enabled = true;
    responsiveOptions = [
        {
            breakpoint: '1400px',
            numVisible: 3
        },
        {
            breakpoint: '768px',
            numVisible: 2
        }
    ];
    get activeIndex() {
        return this._activeIndex;
    }
    set activeIndex(newValue) {
        if (newValue >= 0 && newValue <= (this.media.length - 1)) {
            this._activeIndex = newValue;
            this.updateActiveVideoSources();
        }
    }
    constructor(cdr) {
        this.cdr = cdr;
    }
    ngOnInit() {
        if (this.activeItemChange) {
            this.activeItemChange.subscribe(({ direction } = {}) => {
                if (direction) {
                    switch (direction) {
                        case 'reset':
                            this.activeIndex = 0;
                            break;
                        case 'previous':
                            this.prev();
                            break;
                        case 'next':
                        default:
                            this.next();
                            break;
                    }
                }
            });
        }
    }
    ngOnChanges(changes) {
        if (changes.media?.currentValue) {
            // This detect-and-change is needed in cases where media.length < numVisible (which p-galleria
            // is already doing internally), but also when media.length then increases (which p-galleria is
            // not detecting and changing for), so this kicks it
            if (this.numVisible !== Math.min(DEFAULT_NUM_VISIBLE, changes.media?.currentValue.length)) {
                this.numVisible = Math.min(DEFAULT_NUM_VISIBLE, changes.media?.currentValue.length);
            }
            this.updateActiveVideoSources();
        }
        // This detects when the current event as a whole has changed, and kicks the p-galleria
        // by using a *ngIf to destroy and recreate it. Needed as p-galleria doesn't re-setup everything
        // (like CSS style rules) on `id` change.
        if (changes.id?.currentValue && !changes.id.firstChange) {
            this.enabled = false;
            this.cdr.detectChanges();
            this.enabled = true;
        }
    }
    next() {
        this.activeIndex++;
    }
    prev() {
        this.activeIndex--;
    }
    download(url) {
        if (!url || url === '#') {
            return;
        }
        const downloadUrl = `${window.appConfig.apiBaseUrl}/event/mediaDownload?url=${encodeURIComponent(url)}`;
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    getVideoDownloadUrl(item) {
        const first = item.formats?.[0]?.sslUrl;
        return first ?? item.sslUrl ?? '#';
    }
    trackByFormat(index, format) {
        return format?.type ?? index;
    }
    updateActiveVideoSources() {
        const activeMedia = this.media?.[this.activeIndex];
        const videoElement = this.videoElem?.nativeElement;
        const formats = activeMedia?.formats ?? [];
        if (!videoElement || !activeMedia?.video || formats.length === 0) {
            return;
        }
        // the `sources` tag and/or video element were not auto-updating via change-detection with new media
        // so this is a way to force the video element to update by setting src and calling .load
        formats.forEach((format) => {
            const type = `video/${format.type}`;
            // eslint-disable-next-line unicorn/prefer-spread
            const sourceElements = Array.from(videoElement.querySelectorAll('source'));
            let sourceElem = sourceElements.find(source => source.type === type);
            if (!sourceElem) {
                sourceElem = document.createElement('source');
                sourceElem.type = type;
                videoElement.appendChild(sourceElem);
            }
            sourceElem.src = format.sslUrl;
        });
        videoElement.load();
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        id: [{ type: Input }],
        media: [{ type: Input }],
        activeItemChange: [{ type: Input }],
        selectionChange: [{ type: Output }],
        videoElem: [{ type: ViewChild, args: ['videoElem',] }]
    };
};
GalleriaComponent = __decorate([
    Component({
        selector: 'galleria',
        template: __NG_CLI_RESOURCE__0,
    })
], GalleriaComponent);
export { GalleriaComponent };
